import { z } from 'zod';

/** Schemas compartilhados da API. Fonte única de tipos entre front e back. */

export const healthResponseSchema = z.object({
  ok: z.literal(true),
  service: z.string(),
  version: z.string(),
  time: z.string(),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;
